import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { MaternityLeaveAddEdit, MaternityLeaveListing } from './Pages';

export const MaternityLeaveRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={MaternityLeaveListing} />
        <Route exact path={`${match.path}/addEdit`} component={MaternityLeaveAddEdit} />
    </Fragment>
);